import React, { useState } from "react";
import styled from "styled-components";
import GlobalStyle from "./globalStyle";

import Title from "./components/Title";
import UploadForm from "./components/UploadForm";
import ImageGrid from "./components/ImageGrid";
import Modal from "./components/Modal";

//https://www.youtube.com/watch?v=vUe91uOx7R0&list=PLpOt8kgmeVckE4u9zL441XSPKR1DOUtHi&index=19

const Application = styled.div`
  max-width: 96rem; //960px
  margin: 0 auto; // wyśrodkuj
`;

function App() {
  // state zachowuje url obrazka
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <Application>
      <GlobalStyle />
      <Title />
      <UploadForm />
      <ImageGrid
        setSelectedImg={setSelectedImg} // przekaz w propsach funkkcje która zapisze url obrazka
      />
      {selectedImg && ( // jezeli selectedImg istnieje to redneruj modal
        <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />
      )}
    </Application>
  );
}

export default App;
